import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsService } from '../../@core/utils/analytics.service';
import { REGEX_CONSTANTS } from '../../config/regex.constant';
import { GradeService } from '../../services/grade.service';
import { OpenAIService } from '../../services/open-ai.service';
import { PacingPlanService } from '../../services/pacing-plan.service';
import { StorageService } from '../../services/storage.service';
import { SubjectService } from '../../services/subject.service';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'ngx-super-admin-pacing-plan',
  templateUrl: './super-admin-pacing-plan.component.html',
  styleUrls: ['./super-admin-pacing-plan.component.scss'],
})
export class SuperAdminPacingPlanComponent implements OnInit {
  addPacingPlanForm: FormGroup;
  subjects = [];
  grades: any = [];
  public modalRef;
  currentPage = 1;
  pacingPlans = [];
  totalPages = 1;
  totalCount = 0;
  selectedPacingPlans = [];
  pages = [];
  isCheckedAll = false;
  @ViewChild('deletePacingPlanDialog') deletePacingPlanDialog: TemplateRef<any>;
  @ViewChild('pacingPlan') pacingPlanDialog;
  @ViewChild('editModal') editModal;
  sectionId: string = '';
  sectionTitle: string = '';
  global_pacing_plan_id: number;
  subject_id: number;
  grades_id: number;
  thread_id: string = '';
  loading = false;

  constructor(
    private pacingPlanService: PacingPlanService,
    private fb: FormBuilder,
    private subjectService: SubjectService,
    private gradeService: GradeService,
    public dialog: MatDialog,
    private openAIService: OpenAIService,
    private toasterService: ToasterService,
    public storageService: StorageService,
    public modalService: NgbModal,
    public analytics: AnalyticsService,
    private spinner: NgxSpinnerService,
  ) {}

  async ngOnInit() {
    try {
      this.spinner.show();
      this.getFormControl();
      await this.getAllSubjectsAndGrades();
      await this.getAllGlobalPacingPlans();
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.spinner.hide();
    }
  }

  getFormControl(): void {
    try {
      this.addPacingPlanForm = this.fb.group({
        subject: ['', Validators.required],
        grade: ['', Validators.required],
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async getAllSubjectsAndGrades() {
    try {
      this.subjects = await this.subjectService.getAllSubjects();
      this.grades = await this.gradeService.getAllGrades();
      this.addPacingPlanForm.patchValue({
        subject: this.subjects[0].id,
        grade: this.grades[0].id,
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async getPacingPlansWithPage(isNext = false) {
    try {
      isNext ? this.currentPage++ : this.currentPage--;

      await this.getAllGlobalPacingPlans();
    } catch (error) {
      // console.log(error);
    }
  }

  async getAllGlobalPacingPlans(isNew = false) {
    try {
      this.loading = true;
      if (isNew) {
        this.currentPage = 1;
        this.thread_id = '';
      }

      const body = {
        page: this.currentPage,
        grades_id: this.addPacingPlanForm.value.grade,
        subject_id: this.addPacingPlanForm.value.subject,
      };
      const globalPacingPlans: any = await this.pacingPlanService.getGlobalPacingPlanBySubjectAndGradeId(body);

      this.pacingPlans = globalPacingPlans.items;
      this.totalPages = globalPacingPlans.pageTotal;
      this.totalCount = globalPacingPlans.itemsTotal;
      await this.getAllPages(globalPacingPlans.pageTotal);
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async getAllPages(pageTotal: number) {
    this.pages = [];
    for (let i = 1; i <= pageTotal; i++) {
      this.pages.push(i);
    }
  }

  async openAddPacingPlanDialog(status: string) {
    try {
      if (status === 'add') {
        this.modalRef = this.modalService.open(this.pacingPlanDialog, {
          size: 'lg',
          modalDialogClass: 'mymodal',
          centered: true,
          backdrop: 'static',

          animation: true,
          keyboard: false,
          backdropClass: 'modal-backdrop',
          windowClass: 'custom-overlay-container',
        });

        this.addPacingPlanForm.patchValue({
          subject: this.addPacingPlanForm.value.subject,
          grade: this.addPacingPlanForm.value.grade,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  fixUnterminatedString(jsonString) {
    // Example fix: Ensure the string ends with a closing bracket
    if (!jsonString.trim().endsWith(']')) {
      jsonString += ']';
    }

    // Additional fixes can be applied here as needed

    return jsonString;
  }

  async addPacingPlan() {
    try {
      this.loading = true;
      this.dialog.closeAll();
      this.modalService.dismissAll(this.modalRef);
      const currentSubject = this.subjects.find((subject) => subject.id === this.addPacingPlanForm.value.subject);
      const currentGrade = this.grades.find((grade) => grade.id === this.addPacingPlanForm.value.grade);

      const params = {
        subjectValue: currentGrade.grade + ' ' + 'Grade' + ' ' + currentSubject.subject,
      };

      if (this.thread_id !== '') {
        params['thread_id'] = this.thread_id;
      }

      const response = await this.openAIService.generatePacingPlansWithAssistant(params);

      // console.log("openAiResponse=====", response);

      if (response && response.code === 200) {
        this.thread_id = response.data.thread_id;

        const cleanJsonString = response?.data?.response.replace(/```json|```/g, '');

        // console.log('parsedResponse====', cleanJsonString);

        let resStandards: any = [];
        try {
          const jsonMatch = cleanJsonString.match(REGEX_CONSTANTS.JSON_MATCH);

          if (!jsonMatch) {
            throw new Error('No JSON object or array found in response');
          }

          const parsedStandards = JSON.parse(jsonMatch[0]);
          if (Array.isArray(parsedStandards)) {
            resStandards = parsedStandards;
          } else if (parsedStandards && typeof parsedStandards === 'object') {
            resStandards = [parsedStandards];
          } else {
            throw new Error('Parsed JSON is neither an object nor an array');
          }
        } catch (error) {
          resStandards = this.fixUnterminatedString(cleanJsonString);
          try {
            const parsedStandards = JSON.parse(resStandards);
            if (Array.isArray(parsedStandards)) {
              resStandards = parsedStandards;
            } else if (parsedStandards && typeof parsedStandards === 'object') {
              resStandards = [parsedStandards];
            } else {
              throw new Error('Parsed JSON is neither an object nor an array');
            }
          } catch (error) {
            console.error('Error parsing JSON after fixing:', error.message);
            this.loading = false;
            return null;
          }
        }

        const openAiData = [];

        if (resStandards && resStandards.length > 0) {
          for (const iterator of resStandards) {
            openAiData.push({
              section_id: iterator.StandardID,
              section_title: iterator.Standard,
              grades_id: this.addPacingPlanForm.value.grade,
              subject_id: this.addPacingPlanForm.value.subject,
            });

            if (iterator.Substandards) {
              for (const sub of iterator.Substandards) {
                openAiData.push({
                  section_id: sub.SubstandardID || sub.StandardID,
                  section_title: sub.Substandard || sub.Standard,
                  grades_id: this.addPacingPlanForm.value.grade,
                  subject_id: this.addPacingPlanForm.value.subject,
                });
              }
            }

            if (iterator['Sub-standards'] || iterator['Sub-Standards']) {
              for (const sub of iterator['Sub-standards'] || iterator['Sub-Standards']) {
                openAiData.push({
                  section_id: sub.SubstandardID || sub.StandardID,
                  section_title: sub.Substandard || sub.Standard,
                  grades_id: this.addPacingPlanForm.value.grade,
                  subject_id: this.addPacingPlanForm.value.subject,
                });
              }
            }
          }
        } else {
          await this.addPacingPlan();
        }

        const allPacingPlanBody = {
          grades_id: this.addPacingPlanForm.value.grade,
          subject_id: this.addPacingPlanForm.value.subject,
        };
        const globalPacingPlansForCurrentGradeAndSubject =
          await this.pacingPlanService.getGlobalPacingPlanBySubjectAndGradeId(allPacingPlanBody);
        const pacingPlansToAddInDatabase = await this.updatePacingPlansToAdd(
          globalPacingPlansForCurrentGradeAndSubject,
          openAiData,
        );

        const body = {
          pacing_plan: pacingPlansToAddInDatabase,
        };

        const res = await this.pacingPlanService.addMultipleGlobalPacingPlan(body);
        if (res?.length > 0) {
          this.thread_id = '';
          this.toasterService.showToast('Pacing Plans Added Successfully', 'success');
          await this.getAllGlobalPacingPlans();
        }
      }
      this.loading = false;
      return;
    } catch (error) {
      this.thread_id = '';
      // console.log(error);
      this.loading = false;
      this.toasterService.showToast('Our AI plan is not working please try again after some time', 'danger');
    }
  }

  // async addPacingPlan() {
  //   try {
  //     this.loading = true;
  //     this.dialog.closeAll();
  //     this.modalService.close(this.modalRef);
  //     const currentSubject = this.subjects.find(
  //       (subject) => subject.id === this.addPacingPlanForm.value.subject,
  //     );
  //     const currentGrade = this.grades.find(
  //       (grade) => grade.id === this.addPacingPlanForm.value.grade,
  //     );

  //     const params = {
  //       subjectValue:
  //         currentGrade.grade + ' ' + 'Grade' + ' ' + currentSubject.subject,
  //       assistant_id: 'asst_MaHioBEAxeyPLpiq3nnsKT39',
  //     };

  //     if (this.thread_id !== '') {
  //       params['thread_id'] = this.thread_id;
  //     }

  //     const response =
  //       await this.openAIService.generatePacingPlansWithAssistant(params);

  //     if (response && response.code === 200) {
  //       this.thread_id = response.data.thread_id;

  //       const cleanJsonString = response?.data?.response.replace(
  //         /```json|```/g,
  //         '',
  //       );

  //       let resStandards: any = [];
  //       try {
  //         resStandards = JSON.parse(cleanJsonString);
  //       } catch (error) {
  //         resStandards = this.fixUnterminatedString(cleanJsonString);
  //         try {
  //           resStandards = JSON.parse(resStandards);
  //         } catch (error) {
  //           console.error('Error parsing JSON after fixing:', error.message);
  //           this.loading = false;
  //           return null;
  //         }
  //       }
  //       const openAiData = [];
  //       if (resStandards && resStandards.length > 0) {
  //         for (const iterator of resStandards) {
  //           openAiData.push({
  //             section_id: iterator.StandardID,
  //             section_title: iterator.Standard,
  //             grades_id: this.addPacingPlanForm.value.grade,
  //             subject_id: this.addPacingPlanForm.value.subject,
  //           });
  //         }
  //       } else {
  //         await this.addPacingPlan();
  //       }

  //       const allPacingPlanBody = {
  //         grades_id: this.addPacingPlanForm.value.grade,
  //         subject_id: this.addPacingPlanForm.value.subject,
  //       };
  //       const globalPacingPlansForCurrentGradeAndSubject =
  //         await this.pacingPlanService.getGlobalPacingPlanBySubjectAndGradeId(
  //           allPacingPlanBody,
  //         );
  //       const pacingPlansToAddInDatabase = await this.updatePacingPlansToAdd(
  //         globalPacingPlansForCurrentGradeAndSubject,
  //         openAiData,
  //       );

  //       console.log('pacingplans===', pacingPlansToAddInDatabase);

  //       const body = {
  //         pacing_plan: pacingPlansToAddInDatabase,
  //       };

  //       const res = await this.pacingPlanService.addMultipleGlobalPacingPlan(
  //         body,
  //       );
  //       if (res?.length > 0) {
  //         this.thread_id = '';
  //         this.toasterService.showToast(
  //           'Pacing Plans Added Successfully',
  //           'success',
  //         );
  //         await this.getAllGlobalPacingPlans();
  //       }
  //     }
  //     this.loading = false;
  //     return;
  //   } catch (error) {
  //     this.thread_id = '';
  //     console.log(error);
  //     this.loading = false;
  //     this.toasterService.showToast(
  //       'Our AI plan is not working please try again after some time',
  //       'danger',
  //     );
  //   }
  // }

  // async addPacingPlan() {
  //   try {
  //     this.loading = true;
  //     this.dialog.closeAll();
  //     this.modalService.close(this.modalRef);
  //     const currentSubject = this.subjects.filter(
  //       (subject) => subject.id === this.addPacingPlanForm.value.subject,
  //     );
  //     const currentGrade = this.grades.filter(
  //       (grade) => grade.id === this.addPacingPlanForm.value.grade,
  //     );

  //     const prompt = `Create a separate pacing plan for
  // each day for 90 days for a teacher to teach ${currentSubject[0].subject}
  // for ${currentGrade[0].grade} grade based on the common core standards of California,
  // only displaying following points for each day with labels, 1.Standard Identifier, 2.Standard.`;

  //     const localStorage = this.storageService.getItem(
  //       `${currentSubject[0].subject}${currentGrade[0].grade}`,
  //     );

  //     const messageParams = [
  //       {
  //         role: 'system',
  //         content: 'You are a helpful teacher assistant.',
  //       },
  //       {
  //         role: 'user',
  //         content: `${prompt}`,
  //       },
  //     ];

  //     if (localStorage && localStorage !== '') {
  //       const localStorageParams = this.storageService.getItem(
  //         `${currentSubject[0].subject}${currentGrade[0].grade}`,
  //       );

  //       for (const iterator of localStorageParams) {
  //         messageParams.push(iterator);
  //       }
  //     }

  //     const openAIRes = await this.openAIService.createGlobalPacingPlans(
  //       prompt,
  //     );
  //     if (openAIRes && openAIRes.code !== 200) {
  //       this.toasterService.showToast(
  //         'Our AI plan is not working please try again after some time',
  //         'danger',
  //       );
  //       this.loading = false;
  //       return;
  //     }

  //     const splittedData = await this.splitAIPlanForDay(
  //       openAIRes.data.choices[0].text,
  //     );
  //     if (splittedData.length === 1) {
  //       await this.addPacingPlan();
  //     } else {
  //       const openAiData = [];
  //       for (const [index, iterator] of splittedData.entries()) {
  //         const sectionsData = await this.getSectionIdAndSectionTitle(
  //           index,
  //           iterator,
  //         );

  //         if (
  //           sectionsData &&
  //           sectionsData?.sectionId !== '' &&
  //           sectionsData?.sectionTitle !== ''
  //         ) {
  //           openAiData.push({
  //             section_id: sectionsData.sectionId.slice(2),
  //             section_title: sectionsData.sectionTitle.replace('(+)', ''),
  //             grades_id: this.addPacingPlanForm.value.grade,
  //             subject_id: this.addPacingPlanForm.value.subject,
  //           });
  //         } else {
  //           index > 0 ? null : await this.addPacingPlan();
  //           break;
  //         }
  //       }

  //       const allPacingPlanBody = {
  //         grades_id: this.addPacingPlanForm.value.grade,
  //         subject_id: this.addPacingPlanForm.value.subject,
  //       };
  //       const globalPacingPlansForCurrentGradeAndSubject =
  //         await this.pacingPlanService.getGlobalPacingPlanBySubjectAndGradeId(
  //           allPacingPlanBody,
  //         );

  //       const pacingPlansToAddInDatabase = await this.updatePacingPlansToAdd(
  //         globalPacingPlansForCurrentGradeAndSubject,
  //         openAiData,
  //       );

  //       const body = {
  //         pacing_plan: pacingPlansToAddInDatabase,
  //       };

  //       const res = await this.pacingPlanService.addMultipleGlobalPacingPlan(
  //         body,
  //       );
  //       if (res?.length > 0) {
  //         this.toasterService.showToast(
  //           'Pacing Plans Added Successfully',
  //           'success',
  //         );
  //         await this.getAllGlobalPacingPlans();
  //       }

  //       this.loading = false;

  //       if (
  //         pacingPlansToAddInDatabase &&
  //         pacingPlansToAddInDatabase.length > 0
  //       ) {
  //         this.setLocalStorage(
  //           `${currentSubject[0].subject}${currentGrade[0].grade}`,
  //           openAIRes.content,
  //         );
  //       }
  //     }

  //     this.loading = false;
  //   } catch (error) {
  //     // console.log(error);
  //     this.loading = false;
  //     this.toasterService.showToast(
  //       'Our AI plan is not working please try again after some time',
  //       'danger',
  //     );
  //   }
  // }

  setLocalStorage(key, openAIRes) {
    try {
      const localStorage = this.storageService.getItem(key);

      const assiStantObj = {
        role: 'assistant',
        content: openAIRes,
      };

      const userObj = {
        role: 'user',
        content: 'If more standards exist, continue the pacing plan generation',
      };

      if (localStorage && localStorage !== '') {
        const localStorageData = localStorage;

        localStorageData.push(assiStantObj);
        localStorageData.push(userObj);

        this.storageService.setItem(key, localStorageData);
      } else {
        this.storageService.setItem(key, [assiStantObj, userObj]);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  getUniqueElementsFromCurrentAIData(openAiData) {
    const result = openAiData.filter(
      (item, index, self) => index === self.findIndex((t) => t.section_title === item.section_title),
    );
    return result;
  }

  async updatePacingPlansToAdd(globalPacingPlans, openAiData) {
    try {
      const uniquePacingPlans = this.getUniqueElementsFromCurrentAIData(openAiData);

      const uniqueArr = [];

      for (const iterator of uniquePacingPlans) {
        const isExist = globalPacingPlans.some(
          (x) => x.section_id === iterator.section_id || x.section_title === iterator.section_title,
        );

        if (!isExist) {
          uniqueArr.push(iterator);
        }
      }

      return uniqueArr;
    } catch (error) {
      // console.log(error);
    }
  }

  async rangeBetweenNumbers(lowEnd: number, highEnd: number) {
    try {
      const list = [];
      for (let i = lowEnd; i <= highEnd; i++) {
        list.push(i);
      }

      return list;
    } catch (error) {
      // console.log(error);
    }
  }

  async getSectionIdAndSectionTitle(index: number, splittedString: string) {
    try {
      let newSplittedStr = '';

      if (index < 10) {
        newSplittedStr = splittedString.slice(4);
      } else if (index >= 10 && index < 100) {
        newSplittedStr = splittedString.slice(5);
      } else if (index >= 100) {
        newSplittedStr = splittedString.slice(6);
      }

      const newSentence = newSplittedStr.replace(/Standard/g, 'responseduStandard');
      const splittedData = newSentence.split('responseduStandard');

      if (splittedData.length === 3) {
        return {
          sectionId: splittedData[1].replace(/2\.|Identifier|;|,/g, '').trim(),

          sectionTitle: splittedData[2].slice(2).trim(),
        };
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async splitAIPlanForDay(response: string) {
    try {
      response.replace('\n\n', ' ');
      const responseData = response.includes('Days') ? response.split('Days') : response.split('Day');
      responseData.shift();
      return responseData;
    } catch (error) {
      // console.log(error);
    }
  }

  async openDeletePlanModal(dialog: TemplateRef<any>) {
    try {
      this.dialog.open(this.deletePacingPlanDialog, {
        width: '300px',
        height: '250px',
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async resetPacingPlan() {
    try {
      this.loading = true;

      this.thread_id = '';

      this.dialog.closeAll();

      if (this.selectedPacingPlans && this.selectedPacingPlans.length > 0) {
        const resetPacingPlanBody = {
          pacing_plan_ids: this.selectedPacingPlans,
        };

        await this.pacingPlanService.deleteMultiplePacingPlans(resetPacingPlanBody);
      } else {
        this.currentPage = 1;
        const body = {
          subject_id: this.addPacingPlanForm.value.subject,
          grades_id: this.addPacingPlanForm.value.grade,
        };

        await this.pacingPlanService.deleteAllPacingPlans(body);

        const currentSubject = this.subjects.filter((subject) => subject.id === this.addPacingPlanForm.value.subject);
        const currentGrade = this.grades.filter((grade) => grade.id === this.addPacingPlanForm.value.grade);

        localStorage.removeItem(`${currentSubject[0].subject}${currentGrade[0].grade}`);
      }
      this.isCheckedAll = false;
      this.selectedPacingPlans = [];

      await this.getAllGlobalPacingPlans();

      this.loading = false;
    } catch (error) {
      // console.log(error);
      this.loading = false;
    }
  }

  protected editGlobalPacingPlan(pacingPlan): void {
    try {
      this.modalRef = this.modalService.open(this.editModal, {
        size: 'lg',
        modalDialogClass: 'mymodal',
        centered: true,
        backdrop: 'static',
        animation: true,
        keyboard: false,
        backdropClass: 'modal-backdrop',
        windowClass: 'custom-overlay-container',
      });

      this.sectionId = pacingPlan.section_id;
      this.sectionTitle = pacingPlan.section_title;
      this.global_pacing_plan_id = pacingPlan.id;
      this.subject_id = pacingPlan.subject_id;
      this.grades_id = pacingPlan.grades_id;
    } catch (error) {}
  }

  async updatePacingPlan(): Promise<void> {
    try {
      // close the modal before making the API call
      this.modalService.dismissAll(this.modalRef);
      this.loading = true;
      const body = {
        section_id: this.sectionId,
        section_title: this.sectionTitle,
        global_pacing_plan_id: this.global_pacing_plan_id,
        subject_id: this.subject_id,
        grades_id: this.grades_id,
      };
      const response = await this.pacingPlanService.updateGlobalPacingPlan(body);
      if (response && response.id) {
        await this.getAllGlobalPacingPlans();
        // this.modalService.dismissAll(this.modalRef);
        this.toasterService.showToast('Pacing Plan Updated Successfully', 'success');
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
      this.modalService.dismissAll(this.modalRef);
      this.toasterService.showToast('Failed to Update Pacing Plan', 'danger');
    }
  }

  selectPacingPlans(event, type: string, id?: number): void {
    try {
      if (type === 'all') {
        const data = this.pacingPlans.map((x) => x.id);

        if (event.checked) {
          this.isCheckedAll = true;
          this.selectedPacingPlans = [...this.selectedPacingPlans, ...data];
          this.selectedPacingPlans = [...new Set(this.selectedPacingPlans)];
        } else {
          this.isCheckedAll = false;

          this.selectedPacingPlans = this.selectedPacingPlans.filter((value) => {
            return !data.includes(value);
          });
        }
      } else {
        if (event.checked) {
          this.selectedPacingPlans.push(id);
        } else {
          this.isCheckedAll = false;
          this.selectedPacingPlans.splice(this.selectedPacingPlans.indexOf(id), 1);
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }
}
